import { options } from 'marked';
import { connect } from 'react-redux'
import { Link } from "react-router-dom";
import ReactSelect from 'react-select';
import _ from 'underscore';
import moment from "moment";

var ButtonDropdown = require("components/utility/ButtonDropdown");
var DropDownOptions = require("components/utility/DropDownOptions");
var Glyphicon = require("components/utility/icons/Glyphicon");
var Modal = require("components/utility/AltModal");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var DataRouting = require("lib/routing/DataRouting");
var BookSearchModal = require("components/reading/books/BookSearchModal");
var DateSpanSelector = require("components/data/DateSpanSelector");
var BookDisplay = require("components/reading/books/BookDisplay")
var StudentAvatar = require("components/avatars/StudentAvatar");
var DataExportModal = require("components/data/exports/DataExportModal");

var TextTypes = require("lib/academic/TextTypes");
var Features = require("lib/account/Features");
var PaywallModal = require("components/users/teachers/PaywallModal");
var CurrentUser = require('lib/account/CurrentUser');
var DateSpans = require("lib/data/DateSpans");

var RosterRouting = require("lib/routing/RosterRouting");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var DataSelectors = require("lib/selectors/DataSelectors");
var UIActions = require("lib/actions/UIActions");
var DownloadData = require("lib/data/DownloadData");
var ReactTooltip = require("react-tooltip");

require("data/data_controls.scss");

@connect(
	(state) => {
		var slPrefs = RosterSelectors.globalStudentListPrefs({ state });
		// DatePage populate date will load in the prefs

		return {
			studentLists: RosterSelectors.nonEmptyStudentLists({ state }),
			loadingStudents: RosterSelectors.isLoadingStudentLists({ state }),
			studentsByStudentListID: RosterSelectors.studentsByStudentListID({ state }),
			userName: CurrentUser.get().display_name,
			blockLogReading: !Features.isEnabled(Features.LOG_READING),
			blockDigitalExercises: !Features.isEnabled(Features.DIGITAL_EXERCISES),
			bookRecommendations: (slPrefs.assigned_text_ids || []),
			blockFullData: false, // made constant during freemium updates 07/2022

			dataExportF: DataSelectors.getExportDataF({ state }),

			digests: DataSelectors.digests({ state }),
		}
	},
	(dispatch) => ({
		openLogReadingPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING })),
		openExercisesPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.EXERCISES })),

		openHistoricalDataPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.HISTORICAL_DATA })),

		showZPDReadingLevelsPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.ZPD_READING_LEVELS })),
	})
)
class DataControls extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		// Only for data temporarily overriding what's being provided in props
		this.state = { overrideData: {} };
	}

	showDataExportModal() {
		this.refs.dataExportModal.show();
	}

	hideDataExportModal() {
		this.refs.dataExportModal.hide();
	}

	handlePrint() {
		this.hideDataExportModal()
		setTimeout(function () {
			this.props.printRef.current.handlePrint();
		}.bind(this), 700);
	}

	effectiveData() {
		return _.extend({}, this.props.selectedData, this.state.overrideData);
	}
	confirmEdits() {
		var effectiveData = this.effectiveData();
		delete effectiveData.page; // Start again on page 1
		this.setState({ overrideData: {} }, () => {
			this.props.updateSelectedData(effectiveData);
		});
	}
	toggleStudent(student, wasSelected) {
		if (this.props.blockFullData) {
			this.props.openHistoricalDataPaywall()
		} else {
			var effectiveData = this.effectiveData();
			var effectiveIDs = effectiveData.userIDs;

			if (wasSelected) {
				this.updateOverride({ userIDs: _.without(effectiveIDs, student.id) });
			} else {
				this.updateOverride({ userIDs: effectiveIDs.concat([student.id]) });
			}
		}
	}
	toggleStudentList(studentList, wasSelected) {
		if (this.props.blockFullData) {
			this.props.openHistoricalDataPaywall()
		} else {
			var studentIDs = _.pluck(this.props.studentsByStudentListID[studentList.id], "id");
			var effectiveIDs = this.effectiveData().userIDs;

			if (wasSelected) {
				this.updateOverride({ userIDs: _.difference(effectiveIDs, studentIDs) });

			} else {
				this.updateOverride({ userIDs: _.union(effectiveIDs, studentIDs) });

			}
		}
	}

	// if data filters are taking up >= 80% of row width
	// hide "Export Data" label
	showDataExportSpan() {
		if (this.props.selectedData.subjectType == DataRouting.SUBJECT_STUDENT_DASHBOARD) { return false }

		var flexContainer = document.querySelector(".dataControls");
		return flexContainer && !((flexContainer.children[0].offsetWidth / flexContainer.offsetWidth) >= 0.8)
	}

	downloadData(e) {
		$wr.nope(e);
		var { subjectType, startDate, endDate, userIDs } = this.effectiveData();

		// This is a bit janky; I'd prefer not to have to directly access subject type here
		if (subjectType === DataRouting.SUBJECT_GOALS || subjectType === DataRouting.SUBJECT_OTHER_METRICS || subjectType == DataRouting.SUBJECT_READING_LEVELS || subjectType == DataRouting.SUBJECT_ACTIVITIES || subjectType == DataRouting.SUBJECT_TEACHER_PICKS) {

			var downloadFilename = _.compact(
				[this.props.userName, startDate, endDate, subjectType]
			).join(" - ") + ".csv";
			if (subjectType === DataRouting.SUBJECT_GOALS) {
				var toExport = this.props.dataExportF({ type: "goals", startDate, endDate, userIDs });
			} else if (subjectType === DataRouting.SUBJECT_READING_LEVELS) {
				var toExport = this.props.dataExportF({ type: "rld", userIDs });
			} else if (subjectType === DataRouting.SUBJECT_ACTIVITIES) {
				if (window.location.href.indexOf("everyone") < 0) {
					var toExport = this.props.dataExportF({ type: "expanded-activities", userIDs });
				} else {
					var toExport = this.props.dataExportF({ type: "all-activities", userIDs });
				}
			} else if (subjectType === DataRouting.SUBJECT_TEACHER_PICKS) {
				var toExport = this.props.dataExportF({ type: "teacher-picks", userIDs });
			} else {
				var toExport = this.props.dataExportF({ type: "stats", startDate, endDate, userIDs });
			}
			DownloadData.downloadCSV(toExport.rows, toExport.headers, downloadFilename);
		} else {
			console.error("Unsupport subjectType for downloadData: ", subjectType);
		}
	}

	updateOverride(updateData) {
		this.setState({ overrideData: _.extend({}, this.state.overrideData, updateData) }, function () {
			this.confirmEdits();
		});
	}

	selectDates(startDate, endDate) {
		if (this.props.blockFullData) {
			this.props.openHistoricalDataPaywall()
		} else {
			this.updateOverride({ startDate, endDate });
		}
	}

	onDueDateSelect(dueDate) {
		this.updateOverride({ dueDate });
	}

	onBookSelect(book) {
		this.refs.bookSearchModal.hide();
		this.updateOverride({ textID: book.text_id, textVariety: undefined });
	}

	onDraftSelect(draft) {
		if (draft === 'all') {
			this.updateOverride({ draft: undefined });
		}
		this.updateOverride({ draft });
	}

	selectTextOption(textOption) {
		if (this.props.blockFullData) {
			this.props.openHistoricalDataPaywall()
		} else {
			if (textOption == TextTypes.Varieties.SPECIFIC_TEXT) {
				this.refs.bookSearchModal.show();
			} else {
				this.updateOverride({ textVariety: textOption, textID: undefined });
			}
		}
	}

	selectOrder(orderType) {
		if (this.props.blockFullData) {
			this.props.openHistoricalDataPaywall()
		} else {
			this.updateOverride({ order: DataRouting.ORDER_LABELS[orderType] });
		}
	}

	selectSubjectType(subjectType) {
		if (DataRouting.requiresLogReading(subjectType) &&
			this.props.blockLogReading) {
			this.props.openLogReadingPaywall();
		} else if (DataRouting.requiresDigitalExercises(subjectType) &&
			this.props.blockDigitalExercises) {
			this.props.openExercisesPaywall();
		} else {
			this.updateOverride({ subjectType });
		}
	}

	selectStatus(status) {
		if (this.props.blockFullData) {
			this.props.openHistoricalDataPaywall()
		} else {
			if (status == DataRouting.ALL_STATUS) {
				this.updateOverride({ status: undefined })
			} else {
				this.updateOverride({ status })
			}
		}
	}

	selectReadBookStatus(readBook) {
		this.updateOverride({ readBook: readBook.value });
	}

	canConfirm() {
		// Has to have overridden something
		if (_.isEmpty(this.state.overrideData)) { return false; }

		var effectiveData = this.effectiveData()

		// Has to have a subject type
		if (!effectiveData.subjectType) { return false; }

		// Has to not be the same as the original params
		return !_.isEqual(effectiveData, this.props.selectedData);
	}

	renderStatusSelector() {
		var selectedStatus = this.effectiveData().status;

		// Subject Data Type
		var dropdownOps = _.map(DataRouting.STATUS_OPTIONS, (status) => {
			return (
				<ButtonDropdownOption key={status}
					onClick={this.selectStatus.bind(this, status)}>
					{$wr.toTitleCase(status)}
				</ButtonDropdownOption>
			);
		})

		var displayText = selectedStatus ? $wr.toTitleCase(selectedStatus) : "All Statuses";

		return (
			<ButtonDropdown text={displayText}
				dropdownDisplay="link" className="subjectTypeSelector nested">
				{dropdownOps}
			</ButtonDropdown>
		);
	}

	renderSubjectSelector() {
		var selectedSubjectType = this.effectiveData().subjectType;

		// Subject Data Type
		var subSubjectOps = _.map(DataRouting.getSubjectSubtypes(selectedSubjectType), (subjectType) => {
			var className = "";
			var lockIcon = undefined;
			// if (DataRouting.requiresDigitalExercises(subjectType) && this.props.blockDigitalExercises) {
			// 	return; // Don't even render it
			// 	// if (subjectType == DataRouting.SUBJECT_EXERCISES) {
			// 	// 	return; // Don't even render it
			// 	// }

			// 	// var lockIcon = <Glyphicon icon="lock" />
			// 	// var className = "locked";
			// }
			return (
				<ButtonDropdownOption key={subjectType} className={className}
					onClick={this.selectSubjectType.bind(this, subjectType)}>
					{lockIcon}{subjectType}
				</ButtonDropdownOption>
			);
		})

		// Don't render an empty subject ops
		if (subSubjectOps.length < 2) {
			return null;
		}

		var displayText = selectedSubjectType || "Select Data Type";

		return (
			<ButtonDropdown text={displayText}
				dropdownDisplay="link" className="subjectTypeSelector nested">
				{subSubjectOps}
			</ButtonDropdown>
		);

	}

	renderStudentSelector() {
		var selectors = [];

		var selectedNames = [];
		var effectiveIDs = new Set(this.effectiveData().userIDs);

		_.each(this.props.studentLists, (studentList) => {

			var studentSelectors = [];
			var allSelected = true;

			_.each(this.props.studentsByStudentListID[studentList.id], (student) => {
				if (effectiveIDs.has(student.id)) {
					var isSelected = true;
					selectedNames.push(student.display_name);
				} else {
					var isSelected = false;
					allSelected = false;
				}
				studentSelectors.push(
					<ButtonDropdownOption key={"s-" + student.id}
						preventCollapse={true} className="studentOp"
						onClick={this.toggleStudent.bind(this, student, isSelected)}>

						<input type="checkbox" checked={isSelected} onChange={() => { }} />
						{" "}{student.display_name}
					</ButtonDropdownOption>
				);
			});

			selectors.push(
				<ButtonDropdownOption key={"sl-" + studentList.id}
					preventCollapse={true} className="studentListOp"
					onClick={this.toggleStudentList.bind(this, studentList, allSelected)}>

					<input type="checkbox" checked={allSelected} onChange={() => { }} />
					{" "}{studentList.name}
				</ButtonDropdownOption>
			);

			selectors = selectors.concat(studentSelectors);

		});

		if (this.props.loadingStudents) {
			var currentLabel = "...";

		} else if (selectedNames.length == 0) {
			var currentLabel = "All Students";

		} else if (selectedNames.length == 1) {
			var currentLabel = selectedNames[0];

		} else {
			var uniqueNames = _.uniq(selectedNames);

			var namesLength = uniqueNames.length;
			var currentLabel = namesLength + " Students";

			var sortedNames = $wr.sortByName(uniqueNames, "lastName");
			var slicedNames = _.first(sortedNames, 10);

			if (namesLength > 10) {
				var surplusStudentsCount = namesLength - 10;
				var toolTipText = slicedNames.join(', ') + " + " + surplusStudentsCount + " more";
			} else {
				var toolTipText = slicedNames.join(', ');
			}
		}

		return (
			<ButtonDropdown text={currentLabel} dataTip={toolTipText}
				dropdownDisplay="link" className="studentSelector">
				{selectors}
			</ButtonDropdown>
		);
	}

	findStudent(studentID) {
		var { studentsByStudentListID } = this.props
		return _.findWhere(_.flatten(_.values(studentsByStudentListID)), { id: studentID })
	}

	selectStudent(student) {
		if (this.props.blockFullData) {
			this.props.openHistoricalDataPaywall()
		} else {
			this.updateOverride({ userIDs: [student.id] });
		}
	}

	renderDataExportModal() {
		return (
			<Modal className="dataExportModal" ref="dataExportModal">
				<DataExportModal
					handlePrint={this.handlePrint}
					effectiveData={this.effectiveData()}
					onComplete={this.hideDataExportModal}
				/>
			</Modal>
		)
	}

	renderExportLink() {
		return (
			<a href="#" className="exportLink hideOnPrint" onClick={this.showDataExportModal} data-tip data-for="export">
				{this.showDataExportSpan() && (
					<span className='exportDataText'>Export Data</span>
				)}
				<Glyphicon icon="download-alt" />
				{!this.showDataExportSpan() && (
					<ReactTooltip id="export">
						Export Data
					</ReactTooltip>
				)}
			</a>
		)
	}

	renderSearchableStudentSelector() {
		var students = _.flatten(_.values(this.props.studentsByStudentListID))
		var options = _.map(students, student => {
			return { label: `${student.display_name} (${student.username})`, value: student.display_name, id: student.id }
		})
		var selectedStudent = _.findWhere(options, { id: _.first(this.props.selectedData.userIDs) })
		var selected = selectedStudent ? selectedStudent : options[0]

		return (
			<ReactSelect
				className={"hideOnPrint searchableStudentSelector"}
				value={selected}
				options={options}
				onChange={this.selectStudent}
				clearable={false} />
		)
	}

	renderTextSelector() {
		var effectiveData = this.effectiveData();

		if (DataRouting.allowsTextVariety(effectiveData.subjectType)) {
			var textVarietyOptions = DropDownOptions.Button.TextVarieties({
				onClick: (val) => { this.selectTextOption(val) },
				altOptions: true, className: "topLevel"
			});
		} else {
			var textVarietyOptions = DropDownOptions.Button.TextVarieties({
				onClick: (val) => { this.selectTextOption(val) },
				anyOrSpecific: true, className: "topLevel"
			});
		}

		if (effectiveData.textID) {
			var currentLabel = (
				<BookDisplay textID={effectiveData.textID} />
			)
		} else {
			var currentLabel = TextTypes.Varieties.getAltName(
				effectiveData.textVariety || TextTypes.Varieties.BOTH);
		}

		if (this.props.bookRecommendations.length > 0) {
			textVarietyOptions.push(
				<li className="dropdown-header" key="picks">Teacher Picks</li>
			)
			_.each(this.props.bookRecommendations, (bookID) => {
				var label = (<BookDisplay textID={bookID} />)
				textVarietyOptions.push(
					<ButtonDropdownOption key={bookID} className="bookRecommendation"
						onClick={this.onBookSelect.bind(this, { text_id: bookID })}>
						{label}
					</ButtonDropdownOption>
				);
			});
		}

		return (
			<ButtonDropdown text={currentLabel}
				dropdownDisplay="link" className="textSelector nested">
				{textVarietyOptions}
			</ButtonDropdown>
		);
	}

	renderTimePeriodLabel() {
		var { digests } = this.props
		if (_.isEmpty(digests)) { return null }

		// find unique combo of start_date-end_date
		var uniqDateRanges = _.uniq(_.compact(_.map(digests, d => { return `${d.start_date}-${d.end_date}` })))

		// if all students have the same date range, display range
		// else, display generic message
		if (_.size(uniqDateRanges) == 1) {
			var startDate = moment(_.first(digests).start_date).format("M/DD/YY");
			var endDate = moment(_.first(digests).end_date).format("M/DD/YY");
			var goalPeriodLabel = `${startDate} - ${endDate}`
		} else {
			var goalPeriodLabel = 'Varies by Student'
		}

		return (
			<div className='timePeriodLabel'>
				Goal Period:{" "}
				<span className="spanDates">
					({goalPeriodLabel})
				</span>
			</div>
		);
	}

	renderDateSpanSelector() {
		var effectiveData = this.effectiveData();
		if (DataRouting.allowAllDates(effectiveData.subjectType)) {
			var showAllDates = true;
		}
		return (
			<DateSpanSelector noDatesOption={true} onSelectDates={this.selectDates}
				expectationsSpans={this.props.expectationsDateSpans}
				startDate={effectiveData.startDate} endDate={effectiveData.endDate}
				showAllDates={showAllDates} />
		);
	}

	// VARIATION ON DATESPANSELECTOR ALIGNED WITH WIDGET PERIODS
	renderWidgetDateSpanSelector() {
		var effectiveData = this.effectiveData();
		if (DataRouting.allowAllDates(effectiveData.subjectType)) {
			var showAllDates = true;
		}
		return (
			<DateSpanSelector noDatesOption={true} onSelectDates={this.selectDates}
				expectationsSpans={this.props.expectationsDateSpans}
				startDate={effectiveData.startDate} endDate={effectiveData.endDate}
				showAllDates={showAllDates} updateLocationState={this.updateOverride}
				widgetMode={true} />
		);
	}

	renderDueDateSelector() {
		var effectiveData = this.effectiveData();

		var currentLabel = 'All Due Dates'
		if (effectiveData.dueDate === 'upcoming') {
			currentLabel = 'Upcoming'
		} else if (effectiveData.dueDate === 'past') {
			currentLabel = 'Past Due'
		} else if (effectiveData.dueDate === 'none') {
			currentLabel = 'No Due Date'
		}

		var dueDateDropdownOptions = [
			{
				label: 'All Due Dates',
				key: 'all_dates',
				dueDate: 'all'
			},
			{
				label: 'Upcoming',
				key: 'upcoming_dates',
				dueDate: 'upcoming'
			},
			{
				label: 'Past Due',
				key: 'past_due',
				dueDate: 'past'
			},
			{
				label: 'No Due Date',
				key: 'none',
				dueDate: 'none'
			},
		]

		dueDateDropdownOptions = _.map(dueDateDropdownOptions, option => {
			return (<ButtonDropdownOption key={option.key} className="statusOptions"
				onClick={this.onDueDateSelect.bind(this, option.dueDate)}>
				{option.label}
			</ButtonDropdownOption>)
		})
		return (
			<ButtonDropdown text={currentLabel}
				dropdownDisplay="link" className="draftSelector nested">
				{dueDateDropdownOptions}
			</ButtonDropdown>
		);
	}

	renderDraftSelector() {
		var effectiveData = this.effectiveData();

		var currentLabel = 'Completed & Assigned'
		if (effectiveData.draft === true) {
			currentLabel = 'Assigned'
		} else if (effectiveData.draft === false) {
			currentLabel = 'Completed'
		}

		var statusDropdownOptions = [
			{
				label: 'Completed & Assigned',
				key: 'completed_assigned',
				draft: 'all'
			},
			{
				label: 'Completed',
				key: 'completed',
				draft: 'false'
			},
			{
				label: 'Assigned',
				key: 'assigned',
				draft: 'true'
			}
		]

		statusDropdownOptions = _.map(statusDropdownOptions, option => {
			return (<ButtonDropdownOption key={option.key} className="statusOptions"
				onClick={this.onDraftSelect.bind(this, option.draft)}>
				{option.label}
			</ButtonDropdownOption>)
		})
		return (
			<ButtonDropdown text={currentLabel}
				dropdownDisplay="link" className="draftSelector nested">
				{statusDropdownOptions}
			</ButtonDropdown>
		);
	}

	renderOrderSelector() {
		var orderOps = DropDownOptions.Button.simpleText({
			options: _.keys(DataRouting.ORDER_LABELS), onClick: this.selectOrder
		});

		var order = this.effectiveData().order || DataRouting.ORDER_BY_DATE;
		var displayText = _.invert(DataRouting.ORDER_LABELS)[order];

		return (
			<ButtonDropdown text={displayText}
				dropdownDisplay="link" className="orderSelector">
				{orderOps}
			</ButtonDropdown>
		);
	}

	renderReadBookStatusSelector() {
		var selectedReadBookStatus = this.effectiveData().readBook;

		var currentLabel = 'All'
		if (selectedReadBookStatus == 'yes') {
			currentLabel = 'Read Book'
		} else if (selectedReadBookStatus == 'no') {
			currentLabel = 'Did Not Read Book'
		}

		var dropdownOptions = [
			{
				label: 'All',
				key: 'all',
				value: undefined
			},
			{
				label: 'Read Book',
				key: 'read_book',
				value: 'yes'
			},
			{
				label: 'Did Not Read Book',
				key: 'did_not_read_book',
				value: 'no'
			}
		]

		// Subject Data Type
		var dropdownOps = _.map(dropdownOptions, (op) => {
			return (
				<ButtonDropdownOption key={op.key}
					onClick={this.selectReadBookStatus.bind(this, op)}>
					{$wr.toTitleCase(op.label)}
				</ButtonDropdownOption>
			);
		})

		return (
			<ButtonDropdown text={currentLabel}
				dropdownDisplay="link" className="subjectTypeSelector nested">
				{dropdownOps}
			</ButtonDropdown>
		);
	}

	render() {
		var effectiveData = this.effectiveData();

		var dataExportModal = this.renderDataExportModal()

		if (this.canConfirm()) {
			var confirmButton = (
				<button className="btn buttonPrimary confirmButton" onClick={this.confirmEdits}>
					Show
				</button>
			);
		}

		if (DataRouting.hasPages(effectiveData.subjectType) && (effectiveData.userIDs.length != 1)) {
			var orderSelector = this.renderOrderSelector();
		}

		if (DataRouting.allowDates(effectiveData.subjectType)) {
			var dateSelector = this.renderDateSpanSelector();
			var bookSearchModal = (
				<BookSearchModal ref="bookSearchModal"
					onBookSelect={this.onBookSelect} />
			);
		}

		if (DataRouting.allowDraft(effectiveData.subjectType)) {
			var draftSelector = this.renderDraftSelector();
			var bookSearchModal = (
				<BookSearchModal ref="bookSearchModal"
					onBookSelect={this.onBookSelect} />
			);
		}

		if (DataRouting.allowDueDate(effectiveData.subjectType)) {
			var dueDateSelector = this.renderDueDateSelector();
			var bookSearchModal = (
				<BookSearchModal ref="bookSearchModal"
					onBookSelect={this.onBookSelect} />
			);
		}

		if (DataRouting.allowsText(effectiveData.subjectType)) {
			var textSelector = this.renderTextSelector();
			var bookSearchModal = (
				<BookSearchModal ref="bookSearchModal"
					onBookSelect={this.onBookSelect} />
			);
		}

		if (DataRouting.allowsStatus(effectiveData.subjectType)) {
			var statusSelector = this.renderStatusSelector();
		}

		if (DataRouting.allowsReadBookStatus(effectiveData.subjectType)) {
			var statusSelector = this.renderReadBookStatusSelector();
		}

		if (this.props.selectedData.subjectType == DataRouting.SUBJECT_GOALS) {
			var diffLink =
				RosterRouting.getPath({
					activeView: RosterRouting.VIEWS.GOALS,
				}) + "?edit_expectations=true";
			var editGoalsLink = (
				<span className="editGoalsLink">
					<button className="btn dropdown-toggle btn-link"><a href='https://whooosreading.zendesk.com/hc/en-us/articles/360024761351' target='_blank'>Learn How to Edit Goals</a></button>
				</span>
			)

			var timePeriodLabel = this.renderWidgetDateSpanSelector()
		}
		if (DataRouting.allowsPrinting(effectiveData.subjectType)) {
			var printLink = (
				<a href="#" className="printLink hideOnPrint" onClick={$wr.print} data-tip data-for="print">
					<Glyphicon icon="print" />
					<ReactTooltip id="print">
						<span>Print Page</span>
					</ReactTooltip>
				</a>
			)
		}

		if (DataRouting.allowsDownload(effectiveData.subjectType)) {
			var downloadLink = (
				<a href="#" className="printLink hideOnPrint" onClick={this.downloadData} data-tip data-for="download">
					<Glyphicon icon="download-alt" />
					<ReactTooltip id="download">
						<span>Download CSV</span>
					</ReactTooltip>
				</a>
			)
		}

		if (this.props.selectedData.subjectType != DataRouting.SUBJECT_STUDENT_DASHBOARD) {
			var exportLink = this.renderExportLink()
		}

		if (this.props.selectedData.subjectType == DataRouting.SUBJECT_STUDENT_DASHBOARD) {
			var studentID = _.first(this.props.selectedData.userIDs)
			var student = this.findStudent(studentID)
			if (student) {
				var dataStudentDigestHeader = (
					<div className='dataStudentDigestHeaderContainer'>
						{this.renderExportLink()}
						<div className='student'>
							<StudentAvatar student={student} maxWidth={50} />
							<div className='studentName'>{student.display_name}</div>
						</div>
						{this.renderSearchableStudentSelector()}
					</div>
				)
			}
		}

		if (!DataRouting.allowDates(effectiveData.subjectType) && !DataRouting.allowsText(effectiveData.subjectType) && !DataRouting.allowsPrinting(effectiveData.subjectType)) {
			var emptySection = (
				<div></div>
			)
		}

		return (
			<div className="dataControls">
				<div className="mainControls">
					{dateSelector}
					{timePeriodLabel}
					{editGoalsLink}
					{textSelector}
					{statusSelector}
					{draftSelector}
					{dueDateSelector}
					{confirmButton}
					{bookSearchModal}
					{dataExportModal}
					{dataStudentDigestHeader}
				</div>
				{exportLink && (
					<div className="rightControls">
						{exportLink}
						<span className="badge">New!</span>
					</div>
				)}
			</div>
		);
	}
};

DataControls.WrappedComponent.propTypes = StrictPropTypes({
	// From parent component
	selectedData: PropTypes.object.isRequired,
	updateSelectedData: PropTypes.func.isRequired,

	// Data inserted by @connect
	studentLists: PropTypes.array.isRequired,
	studentsByStudentListID: PropTypes.object.isRequired,
	loadingStudents: PropTypes.bool,
	expectationsDateSpans: PropTypes.array,
	digests: PropTypes.array,
	dataExportF: PropTypes.func,

	blockLogReading: PropTypes.bool,
	blockDigitalExercises: PropTypes.bool,
	blockFullData: PropTypes.bool,
	bookRecommendations: PropTypes.array,
	userName: PropTypes.string,
	printRef: PropTypes.object,

	// Handlers from @connect
	openLogReadingPaywall: PropTypes.func,
	openHistoricalDataPaywall: PropTypes.func,
	openExercisesPaywall: PropTypes.func,
	showZPDReadingLevelsPaywall: PropTypes.func,
	printComponent: PropTypes.func
});

module.exports = DataControls;


// WEBPACK FOOTER //
// ./modules/components/data/DataControls.js